module.exports = __webpack_public_path__ + "static/media/31JFA10.8b0df405.jpg";